<!-- Separate chart instances: an existing heatmap keeps drawing its previous data when updated to an empty result -->
@if (hasData) {
  <ag-charts-angular class="h-full" [options]="options"></ag-charts-angular>
} @else {
  <ag-charts-angular class="h-full" [options]="options"></ag-charts-angular>
}
